module.exports = __webpack_public_path__ + "img/SES_120250002.d90b85cd.jpg";